import { motion } from 'framer-motion'

export function AnimatedBackground() {
    // Generate random stars
    const stars = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 2 + 1,
        duration: Math.random() * 3 + 2,
        delay: Math.random() * 2,
    }))

    return (
        <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
            {/* Base Gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-primary-navy dark:opacity-100 opacity-0 transition-opacity duration-500" />
            <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-slate-100 to-blue-50 dark:opacity-0 opacity-100 transition-opacity duration-500" />

            {/* Animated Gradient Orbs */}
            <motion.div
                className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-gradient-to-br from-primary-blue/20 to-purple-500/20 blur-3xl"
                animate={{
                    x: [0, 100, 0],
                    y: [0, 50, 0],
                    scale: [1, 1.2, 1],
                }}
                transition={{
                    duration: 20,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />
            <motion.div
                className="absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full bg-gradient-to-br from-accent-gold/10 to-orange-500/10 blur-3xl"
                animate={{
                    x: [0, -50, 0],
                    y: [0, -100, 0],
                    scale: [1, 1.1, 1],
                }}
                transition={{
                    duration: 25,
                    repeat: Infinity,
                    ease: 'easeInOut',
                }}
            />

            {/* Animated Stars (Dark Mode Only) */}
            <div className="absolute inset-0 transition-opacity duration-500">
                {stars.map((star) => (
                    <motion.div
                        key={star.id}
                        className="absolute rounded-full dark:bg-white bg-primary-blue/40"
                        style={{
                            left: `${star.x}%`,
                            top: `${star.y}%`,
                            width: `${star.size}px`,
                            height: `${star.size}px`,
                        }}
                        animate={{
                            opacity: [0.2, 1, 0.2],
                            scale: [1, 1.5, 1],
                        }}
                        transition={{
                            duration: star.duration,
                            repeat: Infinity,
                            delay: star.delay,
                            ease: 'easeInOut',
                        }}
                    />
                ))}
            </div>

            {/* Grid Pattern Overlay */}
            <div className="absolute inset-0 bg-[linear-gradient(rgba(74,144,226,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(74,144,226,0.03)_1px,transparent_1px)] bg-[size:50px_50px] dark:opacity-100 opacity-30" />
        </div>
    )
}
